import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=09dbe926"
import script from "./CookieConsent.vue?vue&type=script&lang=ts"
export * from "./CookieConsent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports